import React, {useState} from 'react';

import {Box} from 'src/design/atoms/Box';
import {Divider} from 'src/design/atoms/Divider';
import type {CourseDefinitionQuizQuestionAnswerResponse} from 'src/api/ProactApiClient';
import {CreateButton} from 'src/design/molecules/CreateButton';
import {Subtitle} from 'src/design/atoms/Typography';
import {ContentRow} from 'src/design/atoms/ContentRow';
import {CreateDefaultCourseDefinitionQuizQuestionAnswer} from '../../../../../app/training/courseDefaults';
import {QuestionAnswerForm} from './QuestionAnswerForm';

export interface QuestionAnswersFormProps {
  data: CourseDefinitionQuizQuestionAnswerResponse[];
  mode: 'edit' | 'view';
  onChange: (answers: CourseDefinitionQuizQuestionAnswerResponse[]) => void;
}
export const QuestionAnswersForm: React.FC<QuestionAnswersFormProps> = ({
  data,
  mode,
  onChange,
}) => {
  const [addedIndex, setAddedIndex] = useState<number | undefined>();

  function handleAddNew(): void {
    setAddedIndex(data.length);
    onChange([
      ...data,
      CreateDefaultCourseDefinitionQuizQuestionAnswer(data.length),
    ]);
  }

  function handleChange(
    obj: CourseDefinitionQuizQuestionAnswerResponse,
    index: number
  ): void {
    const newData = Array.from(data);
    newData[index] = obj;
    onChange(newData);
  }

  function handleDelete(
    obj: CourseDefinitionQuizQuestionAnswerResponse,
    index: number
  ): void {
    onChange([...data.slice(0, index), ...data.slice(index + 1, data.length)]);
  }

  return (
    <>
      <ContentRow
        actionNode={
          mode === 'edit' ? (
            <CreateButton
              onClick={handleAddNew}
              size="sm"
              disabled={data.length > 19}>
              Add Answer
            </CreateButton>
          ) : (
            <></>
          )
        }>
        <Subtitle text="Answers" />
      </ContentRow>

      {data?.map((answer, index) => (
        <Box key={index}>
          <Divider />
          <Box mb="md" mt="md">
            <QuestionAnswerForm
              data={answer}
              index={index}
              onChange={handleChange}
              onDelete={handleDelete}
              mode={mode}
              autoFocus={index === addedIndex}
            />
          </Box>
        </Box>
      ))}
    </>
  );
};
